import { useTranslation } from 'react-i18next';
import { KoobButton, KoobModal, KoobTitle } from '@koob/ui';

/**
 * Warns the tour operator, as soon as the travel diary opens, that some products
 * of the itinerary were never distributed to their organization. Those products
 * stay in the diary but with no content and no price, so the TO has to know what
 * the PDF will be missing before sending it to the traveller.
 *
 * Rendered outside #export-target (KoobModal portals into its own dialog), so it
 * never reaches the printed document.
 */
export default function ExportProductAccessModal({ open, onClose, products }) {
  const { t } = useTranslation('tripDesigner');

  if (!products?.length) {
    return null;
  }

  return (
    <KoobModal open={open} setOpen={onClose} widthClass="sm:max-w-3xl ">
      <div className="flex flex-col items-center w-full p-6">
        <div className="flex flex-col items-center gap-y-2">
          <div className="flex items-center justify-center w-11 h-11 rounded-full bg-amber-50">
            <i
              className="fa-light fa-triangle-exclamation text-amber-500"
              style={{ fontSize: 22 }}
            />
          </div>
          <KoobTitle>
            {t('productAccess.exportTitle', { count: products.length })}
          </KoobTitle>
          <p className="text-sm text-gray-500 text-center">
            {t('productAccess.exportDescription')}
          </p>
        </div>

        <ul className="w-full mt-6 space-y-2">
          {products.map((product) => (
            <li
              key={product.key}
              className="flex items-baseline justify-between gap-4 rounded-lg bg-gray-50 px-4 py-2 text-sm"
            >
              <span className="font-medium text-gray-900">
                {product.name ?? t('productAccess.unnamedProduct')}
              </span>
              <span className="shrink-0 text-gray-500">
                {product.type === 'hotel'
                  ? t('productAccess.typeHotel')
                  : t('productAccess.typeExperience')}
              </span>
            </li>
          ))}
        </ul>

        <div className="mt-8">
          <KoobButton variant="primary" onClick={onClose}>
            {t('misc:continue')}
          </KoobButton>
        </div>
      </div>
    </KoobModal>
  );
}
